var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.22,
    height: 30.218,
    viewBox: "0 0 30.22 30.218",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192",
    transform: "translate(-1450.863 -64.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M2231.083,178.289a15.11,15.11,0,1,0-17.471,14.926V182.657h-3.837v-4.368h3.837V174.96c0-3.787,2.255-5.878,5.707-5.878a23.24,23.24,0,0,1,3.382.295V173.1H2220.8a2.184,2.184,0,0,0-2.463,2.36v2.834h4.191l-.67,4.368h-3.521v10.558a15.114,15.114,0,0,0,12.75-14.926",
    transform: "translate(-750 -98.69)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M2221.854,182.656l.67-4.367h-4.191v-2.834a2.184,2.184,0,0,1,2.463-2.36h1.905v-3.719a23.316,23.316,0,0,0-3.382-.294c-3.452,0-5.707,2.091-5.707,5.878v3.329h-3.837v4.367h3.837v10.558a15.234,15.234,0,0,0,4.721,0V182.656Z",
    transform: "translate(-750 -98.69)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb-icon.efbcff9de6b536b59ff3b59811249a71.svg";
export { ForwardRef as ReactComponent };